import moment from 'moment';
import { Component } from 'react';
import { formatMsLong } from '../../../../../../shared/frontend/libs/utils';

type TCountUpTimerState = {
  ticks: number;
  expired: boolean;
  fromTimestamp: any;
};

type TCountUpTimerProps = {
  className?: string;
  style?: Object;
  formatter?: Function;
  onComplete?: Function;
  completed?: any;
  from: string;
};

export default class CountUpTimer extends Component<TCountUpTimerProps, TCountUpTimerState> {
  private interval: any;
  private formatter: any;

  public constructor(props: any, ctx: any) {
    super(props, ctx);
    this.state = {
      ticks: 0,
      expired: false,
      fromTimestamp: null
    };
  }

  public render() {
    if (!this.state.fromTimestamp) {
      return null;
    }

    const delta = moment.duration(moment.utc().diff(this.state.fromTimestamp));

    return (
      <div style={this.props.style || {}} className={this.props.className || ''}>
        {this.formatter(delta.asMilliseconds())}
      </div>
    );
  }

  public UNSAFE_componentWillReceiveProps(nextProps: any) {
    this.formatter = nextProps.formatter || this.defaultFormatter;
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(this.tick, 1000);
    this.setState({
      fromTimestamp: moment.utc(nextProps.from)
    });
  }

  public componentDidMount() {
    this.formatter = this.props.formatter || this.defaultFormatter;
    this.interval = setInterval(this.tick, 1000);
    const targetMoment = moment.utc(this.props.from);
    if (!this.state.fromTimestamp || this.state.fromTimestamp !== targetMoment) {
      // FIXME: how else can we do this to ensure we have a timestamp in state, since
      // componentWillReceiveProps is not called on initial load?
      this.setState({
        fromTimestamp: targetMoment
      });
    }
  }

  public componentWillUnmount() {
    clearInterval(this.interval);
    this.interval = null;
  }

  private defaultFormatter = (ms: any) => {
    return formatMsLong(ms);
  };

  private tick = () => {
    this.setState({ ticks: this.state.ticks + 1 });
  };
}
